module.exports = __webpack_public_path__ + "img/prepare-questions.99dd53ec.svg";